import { useEffect, useState } from "react";
import { useParams } from 'react-router';
import query from "../../../../server/constants.api";
import useFetch from "../../../../server/useFetch";
import { useTranslation } from "react-i18next";
import i18next from 'i18next';
import { BasicTable } from '@synergy/table';
import { Flex } from 'antd';
import { Text } from '../../Atomics/Text';



export const EventsTable = ({ dataToFilter, eventsTableRef, hasEvents, isEventsLoading }) => {
  const { t } = useTranslation();
  const { id } = useParams();

  const [dataEvents, setDataEvents] = useState(null);
  const {
    data: eventsData,
    isLoading: eventsIsLoading,
    refetch: refetchEventsData
  } = useFetch(query.path.detailRegistryEvents, 'getDetailRegistryEvents',
    { id: id, filters: JSON.stringify(dataToFilter) });

  useEffect(() => {
    isEventsLoading(eventsIsLoading)
  }, [eventsIsLoading]);

  useEffect(() => {
    if (eventsData?.data) {
      let array = [];
      eventsData?.data.map((el, idx) => {
        array.push(
          {
            key: idx,
            creationDate: el['Creation Date'],
            eventDescription: el['Event Description'],
            startDate: el['Start Date'],
            endDate: el['End Date'],
            eventSeverity: el['Event Severity']
          }
        )
      })
      setDataEvents(array)
      hasEvents(array)
    }
  }, [eventsData?.data]);

  useEffect(() => {
    hasEvents(null)
    refetchEventsData();
  }, [dataToFilter]);

  return (
    <Flex id='Events' className='ant-anchors-content-item' gap={32} vertical="true">
      <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular' $marginRight='s03'>{t('events')}</Text>
      <div ref={eventsTableRef}>
        <BasicTable tableId='eventsTable' fetchData={dataEvents} language={i18next.resolvedLanguage} />
      </div>
    </Flex>
  )
}